export const GET_HOT_FLOOR_DATA_BEGIN = 'GET_HOT_FLOOR_DATA_BEGIN'
export const GET_HOT_FLOOR_DATA_SUCCESS = 'GET_HOT_FLOOR_DATA_SUCCESS'
export const GET_HOT_FLOOR_DATA_ERROR = 'GET_HOT_FLOOR_DATA_ERROR'
